import { memo } from 'react';

import { getScopedTranslate, useScopedTranslate } from '@locale/translate';
import { abbreviateDate } from '@utils/date';

import { TravellerJourneyAction } from 'api/types';
import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { newDateIgnoreLocalTimezone } from '../timezone';

type ActionType = 'wait_until_fixed_date';

export const getDescription = (action: TravellerJourneyAction<ActionType>) => {
  const { t } = getScopedTranslate(nodeLocale);
  const scheduledDate = action?.scheduledDate ?? action.values?.date?.value;
  const date = newDateIgnoreLocalTimezone(scheduledDate as string);
  return date ? t('triggersNext', { date: abbreviateDate(date, 'en', 'datetime') }) : '';
};

export const Node = memo((node: TravellerJourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={t('title')}
        descriptionText={node.data.nodeDescription}
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    title: 'Wait until # date',
    triggersNext: 'Triggers next action on {date}',
  },
};
